import { useLocale } from '../i18n'

function HomePage() {
  const { t } = useLocale()

  return (
    <div className="content">
      <h2 className="page-title">{t('home.title')}</h2>
      <p className="page-description">{t('home.desc')}</p>
      
      <div className="demo-section">
        <h3>{t('home.howTo')}</h3>
        <p>{t('home.howToDesc')}</p>
      </div>
      
    </div>
  )
}

export default HomePage
